import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthTrackingService } from '@core/services/authTracking.service';
import { ProxyService } from '@core/services/proxy.service';
import { RouterExtService } from '@core/services/routerExtService.service';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { NgRedux } from '@angular-redux/store';
import { IAppState, Actions } from '@core/redux/stores';
import { UtilitiesService } from '@core/services'
import { Constants } from '@core/constants/core.constants';

import { User } from '@core/redux/stores';
import { AuthenticationService } from '@core/services/authentication.service';
import { Observable } from 'rxjs';
import { LoggingService } from '@core/services/logging.service';

@Injectable()
export class EmailVerificationGuard implements CanActivate {

  constructor(
    private router: Router,
    private authTrackingService: AuthTrackingService,
    private proxy: ProxyService,
    private ngRedux: NgRedux<IAppState>,
    private routerExtService: RouterExtService,
    private authenticationService: AuthenticationService,
    private logger: LoggingService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return new Observable<boolean>(
      (observer) => {

        if (this.routerExtService.getCurrentRoute() === '/ordering/orderstatus' &&
         this.routerExtService.getPreviousRoute() === '/order-review') {
          // console.log('restricting navigating back to confirm and pay from order status screen');
          // this.router.navigateByUrl('/ordering/orderstatus');
          // redirecting to home screen to avoid back button functionality anomalies caused in menu with empty cart
          this.router.navigateByUrl('/home');
          observer.next(false);
          observer.complete();
        } else {

         if (this.authTrackingService.isVerified()) {
          observer.next(true);
          observer.complete();
         } else {

            this.proxy.httpGet(ApiRoutes.PROFILE).subscribe(
              (success) => {
                const user = <User>success.body.valueOf();
                user.isEmailVerified = this.authenticationService.getEmailVerificationStatus(user.isEmailVerified);
                if (user.isEmailVerified !== undefined) {
                  this.ngRedux.dispatch({ type: Actions.UPDATEUSERPROFILE, data: user });
                  observer.next(true);
                  observer.complete();
                } else {
                  let currentRoute = this.routerExtService.getCurrentRoute();
                  if (currentRoute === '/') {
                    currentRoute = '/home';
                  }
                  if (!this.authenticationService.getRegisterSignIn()) {
                    this.router.navigate([currentRoute], { queryParams: 
                      UtilitiesService.generateQueryParams([Constants.VERIFY_EMAIL], [true])});
                  }
                  observer.next(false);
                  observer.complete();
                }
              },
              (err) => {
                this.logger.logError(err);
                observer.next(true);
                observer.complete();
              }
            );

        }

       }
      }
    );
  }
}
